import Clock from 'components/Icons/Clock'
import ClockAlert from 'components/Icons/ClockAlert'
import WebhookSetup from 'components/Icons/WebhookSetup'
import palette from 'constants/palette'
import React from 'react'
import type { ConnectionRowStatus } from './providerStatus'

// The glyph for a connection state, in one place because two surfaces report
// the same state — the banner above the hero and the setup card's action block
// — and they must never disagree about it. Sketch prototype v35: a connection
// waiting on its first event is the clock-with-alert, one that has gone quiet
// is the plain clock.
const ConnectionActionIcon = ({ status }: { status: ConnectionRowStatus }) => {
  if (status === 'wait') return <ClockAlert fillColor={palette.grey90} />
  if (status === 'reconnect') return <Clock fillColor={palette.grey90} />
  return <WebhookSetup strokeColor={palette.grey90} />
}

export default ConnectionActionIcon
